// extracted by mini-css-extract-plugin
export default {"requestBlock":"RequestBlock_requestBlock__HdzjV","btn":"RequestBlock_btn__12IWn"};